// extracted by mini-css-extract-plugin
export default {"very_large":"2.5rem","XXX_large":"1.875rem","XX_large":"1.5625rem","extra_large":"1.25rem","large":"1rem","regular":".875rem","small":".75rem","extra_small":".625rem"};